require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/map/map.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/map/map.legacy.js
// module id = 678
// module chunks = 31